var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollectionNewDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    fill: "#00E676",
    stroke: "#525F6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionNewDark);
export default __webpack_public_path__ + "static/media/collectionNewDark.d45d44ec6101834b4115b71ccd4535fb.svg";
export { ForwardRef as ReactComponent };